import { render, staticRenderFns } from "./score-sort.vue?vue&type=template&id=c422b9c4&scoped=true"
import script from "./score-sort.vue?vue&type=script&lang=js"
export * from "./score-sort.vue?vue&type=script&lang=js"
import style0 from "./score-sort.vue?vue&type=style&index=0&id=c422b9c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c422b9c4",
  null
  
)

export default component.exports